import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full min-h-[90vh] flex flex-col items-center justify-center py-20 px-4 bg-brand-bg overflow-hidden border-b border-brand-card" data-id="element-66">
      {/* Background texture/grain effect could go here */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-brand-bg-alt to-brand-bg opacity-50 pointer-events-none" data-id="element-67" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="mb-8" data-id="element-69">
          <span className="inline-block py-1 px-3 border border-brand-accent/30 rounded-full text-brand-accent text-sm font-bold tracking-wider uppercase mb-6 bg-brand-accent/5" data-id="element-70">
            For Retired Men Only
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-serif font-bold leading-[1.15] text-white mb-6 drop-shadow-lg px-2" data-id="element-71">
            After 40 Years of Hard Work,{' '}
            <span className="text-brand-highlight" data-id="element-72">
              Why Does Your Own Living Room Feel Like a Battlefield?
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-brand-text-muted max-w-3xl mx-auto font-sans font-light" data-id="element-73">
            The tactical playbook for retired men who are home all day — and
            over it.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative mb-12 group" data-id="element-74">
          <div className="absolute -inset-4 bg-brand-accent/20 blur-3xl rounded-full opacity-50 group-hover:opacity-75 transition-opacity duration-700" data-id="element-75" />
          <img src="https://cdn.magicpatterns.com/uploads/a3qNzLvMSBEYwcS9FxZVPe/heylloyd-image-1771301560299.png" alt="Home-All-Day Reset Playbook on Tablet" className="relative w-full max-w-md md:max-w-lg rounded-lg shadow-2xl border border-brand-card/50 transform transition-transform duration-700 hover:scale-[1.02]" data-id="element-76" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} data-id="element-77">
          <a href="#pricing" onClick={e => {
          e.preventDefault();
          document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          });
        }} className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white bg-brand-accent hover:bg-brand-accent-hover rounded-md shadow-[0_0_20px_rgba(230,126,34,0.3)] hover:shadow-[0_0_30px_rgba(230,126,34,0.5)] transition-all duration-300 group" data-id="element-78">
            Get the Playbook — $6.36
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-79" />
          </a>
          <p className="mt-4 text-sm text-brand-text-muted" data-id="element-80">
            Instant Digital Download • Secure Checkout
          </p>
        </motion.div>
      </div>
    </section>;
}